import { useTheme } from "@/client/providers/ThemeProvider";
import { use, type PropsWithChildren } from "react";
import type { BundledLanguage, BundledTheme } from "shiki";
import { Button } from "../shad/button";
import { ButtonGroup } from "../shad/button-group";
import { IconCopy, IconRefresh } from "@tabler/icons-react";

type CodeBlockProps = {
  code: string;
  lang?: BundledLanguage;
  theme?: BundledTheme;
};

const shikiPromise = import("shiki");

export const CodeBlock = ({ children }: PropsWithChildren) => {
  return (
    <div className="mt-4">
      <header className="rounded-t-md flex items-center border border-b-0 bg-secondary/40 px-2 py-2 text-xs">
        <ButtonGroup className="grow text-muted-foreground">
          <Button variant="ghost" size="xs">
            schema.ts
          </Button>
          <Button variant="ghost" size="xs">
            example.ts
          </Button>
        </ButtonGroup>
        <ButtonGroup>
          <Button variant="secondary" size="xs">
            <IconCopy />
          </Button>
        </ButtonGroup>
      </header>
      <div>{children}</div>
    </div>
  );
};

export function CodeBlockSnippet({
  code,
  lang = "typescript",
}: CodeBlockProps) {
  const { theme } = useTheme();

  const shiki = use(shikiPromise);

  const codeTheme = theme === "dark" ? "vitesse-dark" : "github-light";

  const html = use(
    shiki.codeToHtml(code, {
      lang,
      theme: codeTheme,
    }),
  );

  return (
    <div
      className="rounded-b-md border overflow-hidden"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
